export function getTimezone(): string{
  const now = new Date();
  const offsetMinutes = now.getTimezoneOffset();

  // El signo se invierte porque getTimezoneOffset() devuelve
  // minutos positivos para zonas al oeste de UTC.
  const sign = offsetMinutes <= 0 ? "+" : "-";

  const hours = Math.abs(Math.floor(offsetMinutes / 60));
  const minutes = Math.abs(offsetMinutes % 60);

  // Formatear a dos dígitos (ej: 05)
  const horasPad = String(hours).padStart(2, '0');
  const minutesPad = String(minutes).padStart(2, '0');

  return `${sign}${horasPad}:${minutesPad}`;
}

export function getTodayDate(): string {
  const now = new Date();
  const timezone = getTimezone();
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: timezone,
  };
  return new Intl.DateTimeFormat('en-CA', options).format(now);
}

export function getStartToday(): string {
  const today = getTodayDate();

  return new Date(`${today}T00:00:00`).toJSON();
}

export function getEndToday(): string {
  const startToday = new Date(getStartToday());

  return new Date(startToday.getTime() + (1000 * 60 * 60 * 24) - 1).toJSON()
}

